import React from "react";


// @material-ui/icons
import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
import MDAvatar from "components/MDAvatar";
import { Box } from '@mui/material';
import { Alert } from '@mui/material';

// core components
import { useQuery } from "react-query";
import podImage from "assets/img/pod-unlabeled.png";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";

import axios from "axios";

export default function PodTable(props) {
  const url = "/api/v1/k8s/pods";
  const [token, setToken] = useToken();
  useAxiosAuth(token);
  const PodName = ({ image, name }) => (
      <MDAvatar src={image} name={name} size="sm" />
  );
  const columns = [
    { Header: "", accessor: "icon", width: "1px"},
    { Header: "name", accessor: "name", width: "37%", align: "left" },
    { Header: "namespace", accessor: "namespace", align: "left" },
    { Header: "container count", accessor: "containers", width: "20%", align: "center" },
    { Header: "pod IP", accessor: "podIP", align: "center" },
    { Header: "status", accessor: "phase", align: "center" },
  ];

  const { isLoading, error, data } = useQuery(
    "pod", () => axios.get(
      url,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => {
        return (res.hasOwnProperty('data') && res.data.hasOwnProperty('data')) ? res.data.data : null
      }
    )
  )

  const podData = (data) => {
    let tableData = {
      columns: columns,
      rows: []
    };

    if (data) {
      if ("items" in data) {
        tableData.rows = data.items.map((item) => {
            const name = (item.name) ? item.name : ""
            return {
              icon: <PodName image={podImage} name={name} />,
              name: name,
              namespace: (item.namespace) ? item.namespace : "",
              containers: (item.containers_count) ? item.containers_count : "",
              podIP: (item.podIP) ? item.pod_ip : "",
              phase: (item.phase) ? item.phase : ""
            }
          }
        )
      }
    }

    return tableData;
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }
      {(isLoading && !error) && <CircularProgress size={30} style={{marginLeft: '45%', position: 'absolute',  top : '30%' ,  zIndex: '1'}}/> }
      {(!isLoading && !error) && 
        <DataTable
          table={ podData(data) }
          canSearch={true}
          showTotalEntries={true}
          isSorted={true}
          noEndBorder
          entriesPerPage={true}
        />
      }
    </React.Fragment>
  );
}
